/** Light and dark themes (CSS variables on [data-theme]); dark by default, like PRISM. PRISM's host:theme arrives in M5. */
export type Theme = 'dark' | 'light';

export function getTheme(): Theme {
  try {
    return localStorage.getItem('pg.theme') === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem('pg.theme', theme);
  } catch {
    // session only
  }
}

export function applyStoredTheme(): void {
  document.documentElement.dataset.theme = getTheme();
}
